<template>
  <div class="container boxShadow">
    <h5>场馆预约 <span>（提前一周预约）</span> </h5>
    <div class='cont'>
      <div class="legends" v-if="currentlist.length != 0">
        <span class="legend kyd">可预订</span>
        <span class="legend yyd">已预订</span>
        <span>{{dateFormat}}场地预定情况</span>
      </div>
      <div class="tabbar">
        <div :class="activeType==index?'btn btn-primary':'btn btn-default'" @click="changeType(index,item)" v-for="item,index in data">{{item.name}}</div>
      </div>
      <div class="table">
        <div class="row" v-for="item,index in currentlist">
          <div>{{item.date}} {{getWeek(item.date)}}</div>
          <div v-for="child in item.list">
            <div :class="child.status==1?'btn btn-default':'btn btn-primary'" @click="linkToOrder(child)">{{child.start}} - {{child.end}}</div>
          </div>
        </div>
        <!-- <div class="row">
                    <div>2019-11-18 周一</div>
                    <div>
                        <div class="btn btn-primary">09:00-11:30</div>
                    </div>
                    <div>
                        <div class="btn btn-primary">09:00-11:30</div>
                    </div>
                    <div>
                        <div class="btn btn-primary">09:00-11:30</div>
                    </div>
                </div>
                <div class="row">
                    <div>2019-11-18 周一</div>
                    <div>
                        <div class="btn btn-primary">09:00-11:30</div>
                    </div>
                    <div>
                        <div class="btn btn-primary">09:00-11:30</div>
                    </div>
                    <div>
                        <div class="btn btn-primary">09:00-11:30</div>
                    </div>
                </div>
                <div class="row">
                    <div>2019-11-18 周一</div>
                    <div>
                        <div class="btn btn-primary">09:00-11:30</div>
                    </div>
                    <div>
                        <div class="btn btn-primary">09:00-11:30</div>
                    </div>
                    <div>
                        <div class="btn btn-primary">09:00-11:30</div>
                    </div>
                </div> -->

      </div>
    </div>
    <div class="user_center" @click="$router.push('/account')">
      个人中心
    </div>
  </div>
</template>

<script>
export default {
  inject: ['ajax'],
  data() {
    return {
      data: [],
      activeType: 0,
      currentlist: [],
      date: ''
    };
  },
  computed: {
    dateFormat() {
      let arr = this.date.split('-')
      return `${arr[0]}年${arr[1]}月${arr[2]}日 - ${arr[3]}年${arr[4]}月${arr[5]}日`
    }
  },
  created() {

  },
  mounted() {
    this.ajax('/api/reserve/index', 'get', '', res => {
      let obj = res.data.data.data
      this.date = res.data.data.date
      let d = []
      for (let key in obj) {
        d.push({
          name: key,
          list: obj[key]
        })
      }
      this.data = d
      let list = []
      for (let key in this.data[0].list) {
        list.push({
          date: key,
          list: this.data[0].list[key]
        })
      }
      this.currentlist = list
    })
  },
  watch: {

  },
  methods: {
    linkToOrder(item) {
      if (item.status == 0) {
        this.$router.push({
          path: '/notice2',
          query: {
            id: item.id
          }

        })
      }

    },
    // 获取星期
    getWeek(date) {
      let d = new Date(date)
      let week = ['周日', '周一', '周二', '周三', '周四', '周五', '周六']
      return week[d.getDay()]
    },
    // 切换
    changeType(index, item) {
      if (this.activeType != index) {
        this.activeType = index
        let list = []
        for (let key in item.list) {
          list.push({
            date: key,
            list: item.list[key]
          })
        }
        this.currentlist = list
      }
    }
  },
  components: {

  },
};
</script>

<style scoped>
.container {
  background: #fff;
  padding: 50px;
}

.container > h5 {
  font-size: 1.3em;
  color: #333333;
  text-align: center;
  padding-bottom: 20px;
  border-bottom: 1px solid #eeeeee;
}

.container > h5 > span {
  color: #999999;
  font-weight: normal;
}

.cont {
  padding: 20px 0;
}

.legends {
  text-align: center;
  color: #333;
  font-size: 1em;
  font-weight: bold;
}

.legend {
  font-style: italic;
  padding-left: 30px;
  position: relative;
  margin: 0 1em;
}

.legend::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 1em;
  height: 1em;
  border-radius: 5px;
}

.kyd::before {
  background: #4ba6ff;
  border: 1px solid #4ba6ff;
}

.yyd::before {
  background: #eeeeee;
  border: 1px solid #dedede;
}

.tabbar {
  display: flex;
  padding: 30px 210px;
  justify-content: space-between;
}

.table {
  border-top: 1px solid #0677e4;
  padding: 5px 0;
}

.row {
  display: flex;
  color: #333;
  font-weight: bold;
  padding: 12px 0;
  align-items: center;
}
.row:nth-child(2n) {
  background: #f5f5f5;
}
.row > div {
  text-align: center;
  width: 33.3%;
}
@media only screen and (max-width: 750px) {
  .container > h5 {
    font-size: 1em;
    padding-bottom: 0.1rem;
  }
  .cont .item {
    width: 100%;
  }
  .container {
    padding: 0.2rem;
  }
  .legends {
    font-size: 0.13rem;
  }
  .tabbar {
    padding: 0.15rem 0;
  }
  .tabbar .btn {
    font-size: 0.12rem;
    width: 0.6rem;
  }
  .row {
    font-size: 0.12rem;
  }
  .row .btn {
    width: 0.55rem;
  }
}
</style>